// extracted by mini-css-extract-plugin
module.exports = {"title":"TextAndTitlesBlock-module--title--1k9yV","subTitle":"TextAndTitlesBlock-module--sub-title--2PltS"};